import {
  Component, OnInit, OnDestroy,
} from '@angular/core';
import { BulletinBoardService } from 'src/app/services/bulletin-board.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service'; // Import ToastService

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: [ './posts.component.scss' ],
})
export class PostsComponent implements OnInit, OnDestroy {
  isLoading = false;
  posts: any[] = [];
  postsData$ = this.bulletinBoardService.postsData$;
  postsSubscription = this.postsData$.subscribe((data) => {
    this.isLoading = false;
    if (!data) {
      return;
    }

    this.posts = data.rows;
  });
  permissions: any;
  permissionsSubscription: any;

  constructor(
    private bulletinBoardService: BulletinBoardService,
    private router: Router,
    private auth: AuthService,
    private toastService: ToastService, // Add ToastService to constructor
  ) {}

  ngOnInit(): void {
    this.permissionsSubscription = this.auth.permissions$.subscribe((permissions: any) => {
      this.permissions = permissions;
    });
    this.searchForPosts();
  }

  searchForPosts() {
    this.isLoading = true;
    this.bulletinBoardService.getPosts({
      limit: 0,
      offset: 0,
      activeFlag: 1,
    }).subscribe({
      next: (response: any) => {
        this.posts = response.data.rows;
        this.isLoading = false;
      },
      error: (error) => {
        console.log('error', error);
        this.isLoading = false;
        this.posts = [];
        this.toastService.setToast({
          text: error.error.message || error.message || 'Failed to load posts',
          type: 'error',
          icon: 'error',
          dismissible: true,
        });
      },
    });
  }

  formatDate = (date) => {
    const dt = new Date(date)
    const month = dt.getMonth() + 1
    const day = dt.getDate()
    const year = dt.getFullYear().toString().slice(2, 4)
    return month < 10 ? `0${month}/${day}/${year}` : `${month}/${day}/${year}`
  }

  formatTime = (publishedDate) => {
    const date = new Date(publishedDate)
    let hours = date.getHours();
    let minutes = date.getMinutes().toString();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes.padStart(2, '0')
    const time = hours + ':' + minutes + ' ' + ampm;
    return time
  }

  getPostTime = (post) => {
    return `${this.formatDate(post.publishedDate)}, ${this.formatTime(post.publishedDate)}`
  }

  goToPost = (post) => {
    this.router.navigate([ `/bulletin-board/${post.id}` ])
  }

  addNewPost = () => {
    this.router.navigate([ '/bulletin-board/new' ])
  }

  ngOnDestroy() {
    this.postsSubscription.unsubscribe();
  }

}
